var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function sumChildMainSize(group, isRow, gap) {
    var total = 0;
    for (var i = 0; i < group.children.length; i++) {
        var b = group.children[i].getBounds();
        total += (isRow ? b.width : b.height) + (i > 0 ? gap : 0);
    }
    return total;
}
/** Flex layout with wrap, align, and justify. */
export function flexLayout(group, options) {
    var e_1, _a, e_2, _b, e_3, _c;
    var _d;
    if (options === void 0) { options = {}; }
    var _e = options.direction, direction = _e === void 0 ? 'row' : _e, _f = options.gap, gap = _f === void 0 ? 8 : _f, _g = options.padding, padding = _g === void 0 ? 0 : _g, _h = options.align, align = _h === void 0 ? 'start' : _h, _j = options.justify, justify = _j === void 0 ? 'start' : _j, _k = options.wrap, wrap = _k === void 0 ? false : _k, width = options.width, height = options.height;
    var isRow = direction === 'row';
    var bounds = group.getBounds();
    var intrinsic = sumChildMainSize(group, isRow, gap);
    var containerSize = (_d = (isRow ? width : height)) !== null && _d !== void 0 ? _d : ((isRow ? bounds.width : bounds.height) || intrinsic || 800);
    var maxMain = Math.max(containerSize - padding * 2, 0);
    var rows = [];
    var current = { items: [], mainSize: 0, crossSize: 0 };
    try {
        for (var _l = __values(group.children), _m = _l.next(); !_m.done; _m = _l.next()) {
            var child = _m.value;
            var b = child.getBounds();
            var main = isRow ? b.width : b.height;
            var cross = isRow ? b.height : b.width;
            if (wrap && current.items.length > 0 && current.mainSize + gap + main > maxMain) {
                rows.push(current);
                current = { items: [], mainSize: 0, crossSize: 0 };
            }
            current.items.push(child);
            current.mainSize += (current.items.length > 1 ? gap : 0) + main;
            current.crossSize = Math.max(current.crossSize, cross);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_m && !_m.done && (_a = _l.return)) _a.call(_l);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (current.items.length > 0)
        rows.push(current);
    var crossOffset = padding;
    try {
        for (var rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
            var row = rows_1_1.value;
            var mainOffset = padding;
            var freeSpace = maxMain - row.mainSize;
            var extraGap = gap;
            if (justify === 'center')
                mainOffset += freeSpace / 2;
            else if (justify === 'end')
                mainOffset += freeSpace;
            else if (justify === 'space-between' && row.items.length > 1) {
                extraGap = gap + freeSpace / (row.items.length - 1);
            }
            else if (justify === 'space-around' && row.items.length > 0) {
                extraGap = gap + freeSpace / row.items.length;
                mainOffset += freeSpace / (row.items.length * 2);
            }
            try {
                for (var _o = (e_3 = void 0, __values(row.items)), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var child = _p.value;
                    var b = child.getBounds();
                    var cross = isRow ? b.height : b.width;
                    var crossPos = crossOffset;
                    if (align === 'center')
                        crossPos += (row.crossSize - cross) / 2;
                    else if (align === 'end')
                        crossPos += row.crossSize - cross;
                    else if (align === 'stretch') {
                        /* stretch not applied to bounds in html fallback */
                    }
                    if (isRow) {
                        child.x = mainOffset;
                        child.y = crossPos;
                        mainOffset += b.width + extraGap;
                    }
                    else {
                        child.x = crossPos;
                        child.y = mainOffset;
                        mainOffset += b.height + extraGap;
                    }
                    child.markDirty();
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_c = _o.return)) _c.call(_o);
                }
                finally { if (e_3) throw e_3.error; }
            }
            crossOffset += row.crossSize + gap;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (rows_1_1 && !rows_1_1.done && (_b = rows_1.return)) _b.call(rows_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** Grid layout */
export function gridLayout(group, options) {
    var e_4, _a;
    if (options === void 0) { options = {}; }
    var _b = options.columns, columns = _b === void 0 ? 3 : _b, _c = options.gap, gap = _c === void 0 ? 10 : _c, _d = options.padding, padding = _d === void 0 ? 0 : _d;
    var x = padding;
    var y = padding;
    var col = 0;
    var rowHeight = 0;
    try {
        for (var _e = __values(group.children), _f = _e.next(); !_f.done; _f = _e.next()) {
            var child = _f.value;
            var b = child.getBounds();
            child.x = x;
            child.y = y;
            rowHeight = Math.max(rowHeight, b.height);
            col++;
            if (col >= columns) {
                col = 0;
                x = padding;
                y += rowHeight + gap;
                rowHeight = 0;
            }
            else {
                x += b.width + gap;
            }
            child.markDirty();
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_4) throw e_4.error; }
    }
}
/** Stack layout (vertical or horizontal) */
export function stackLayout(group, options) {
    if (options === void 0) { options = {}; }
    flexLayout(group, __assign(__assign({}, options), { wrap: false }));
}
/** Flex-like layout — full flexbox implementation */
// flexLayout defined above
/** Flow layout - wrap items */
export function flowLayout(group, options) {
    var _a;
    if (options === void 0) { options = {}; }
    gridLayout(group, __assign(__assign({}, options), { columns: (_a = options.columns) !== null && _a !== void 0 ? _a : 4 }));
}
/** Circular layout */
export function circularLayout(group, cx, cy, radius) {
    var n = group.children.length;
    if (n === 0)
        return;
    for (var i = 0; i < n; i++) {
        var angle = (2 * Math.PI * i) / n - Math.PI / 2;
        var child = group.children[i];
        child.x = cx + radius * Math.cos(angle);
        child.y = cy + radius * Math.sin(angle);
        child.markDirty();
    }
}
/** Tree layout — parents centered over their children (org-chart style). */
export function treeLayout(group, levelGap, siblingGap) {
    if (levelGap === void 0) { levelGap = 80; }
    if (siblingGap === void 0) { siblingGap = 40; }
    layoutTreeSubtree(group, levelGap, siblingGap);
    group.markDirty();
}
function nodeCardWidth(node) {
    var _a;
    var metaW = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.orgCardWidth;
    if (typeof metaW === 'number' && metaW > 0)
        return metaW;
    var b = node.getBounds();
    return Math.max(b.width > 0 ? Math.min(b.width, 220) : 156, 40);
}
/** Org / tree children only — skip chrome, indicators, edge layers, and collapsed branches. */
function treeChildren(node) {
    var orgKids = node.children.filter(function (c) {
        var _a;
        return !!((_a = c.metadata) === null || _a === void 0 ? void 0 : _a.orgNode) &&
            c.visible !== false &&
            'children' in c;
    });
    if (orgKids.length > 0)
        return orgKids;
    return node.children.filter(function (c) {
        var _a, _b;
        return 'children' in c &&
            Array.isArray(c.children) &&
            c.visible !== false &&
            !((_a = c.metadata) === null || _a === void 0 ? void 0 : _a.diagramEdgeLayer) &&
            !((_b = c.metadata) === null || _b === void 0 ? void 0 : _b.orgCollapseBtn);
    });
}
/**
 * Recursively size subtrees and center each parent over its children.
 * Child coordinates are local to the parent group.
 * @returns subtree width used for sibling packing
 */
function layoutTreeSubtree(node, levelGap, siblingGap) {
    var e_5, _a;
    var kids = treeChildren(node);
    var ownW = nodeCardWidth(node);
    if (kids.length === 0) {
        node.markDirty();
        return ownW;
    }
    var widths = [];
    var total = 0;
    try {
        for (var kids_1 = __values(kids), kids_1_1 = kids_1.next(); !kids_1_1.done; kids_1_1 = kids_1.next()) {
            var child = kids_1_1.value;
            var w = layoutTreeSubtree(child, levelGap, siblingGap);
            widths.push(w);
            total += w;
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (kids_1_1 && !kids_1_1.done && (_a = kids_1.return)) _a.call(kids_1);
        }
        finally { if (e_5) throw e_5.error; }
    }
    total += siblingGap * (kids.length - 1);
    var cursor = (ownW - total) / 2;
    kids.forEach(function (child, i) {
        var slot = widths[i];
        var childOwn = nodeCardWidth(child);
        child.x = cursor + (slot - childOwn) / 2;
        child.y = levelGap;
        child.markDirty();
        cursor += slot + siblingGap;
    });
    node.markDirty();
    return Math.max(ownW, total);
}
/** Auto-align children */
export function alignChildren(group, alignment) {
    var e_6, _a;
    var bounds = group.getBounds();
    try {
        for (var _b = __values(group.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            var b = child.getBounds();
            switch (alignment) {
                case 'left':
                    child.x = bounds.x;
                    break;
                case 'center':
                    child.x = bounds.x + (bounds.width - b.width) / 2;
                    break;
                case 'right':
                    child.x = bounds.x + bounds.width - b.width;
                    break;
                case 'top':
                    child.y = bounds.y;
                    break;
                case 'middle':
                    child.y = bounds.y + (bounds.height - b.height) / 2;
                    break;
                case 'bottom':
                    child.y = bounds.y + bounds.height - b.height;
                    break;
            }
            child.markDirty();
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_6) throw e_6.error; }
    }
}
/** Distribute spacing evenly */
export function distributeSpacing(group, axis) {
    var e_7, _a;
    var children = group.children;
    if (children.length < 2)
        return;
    var bounds = group.getBounds();
    var totalSize = children.reduce(function (sum, c) { return sum + (axis === 'x' ? c.getBounds().width : c.getBounds().height); }, 0);
    var gap = (axis === 'x' ? bounds.width : bounds.height - totalSize) / (children.length - 1);
    var offset = axis === 'x' ? bounds.x : bounds.y;
    try {
        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var child = children_1_1.value;
            if (axis === 'x') {
                child.x = offset;
                offset += child.getBounds().width + gap;
            }
            else {
                child.y = offset;
                offset += child.getBounds().height + gap;
            }
            child.markDirty();
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
        }
        finally { if (e_7) throw e_7.error; }
    }
}
export var Layout = {
    grid: gridLayout,
    stack: stackLayout,
    flex: flexLayout,
    flow: flowLayout,
    circular: circularLayout,
    tree: treeLayout,
    align: alignChildren,
    distribute: distributeSpacing,
};
